import store from "@/store";

/**
 * Function to send tracking events to SCA server
 * @param {string} eventType - Type of event ('place_bid', 'bid_limit_reached', 'authorize')
 * @param {object} additionalData - Additional data to send with the event
 *   - auction_id: Internal auction ID
 *   - bid_amount: Bid amount
 *   - bidder_id: User ID
 *   - stock_number: Vehicle stock number
 *   - limit_type: Type of limit reached (for bid_limit_reached events)
 */
export function sendTrackingEvent(eventType, additionalData = {}) {
    try {
        const userId = store.getters['userId'];

        // Check if this is our user
        if (additionalData.bidder_id && additionalData.bidder_id !== userId) {
            return;
        }

        // Get cookie for limit calculations
        const limitCookie = document.cookie
            .split('; ')
            .find(row => row.startsWith('sold_cars_info='));

        // Get initial limits from store
        const initialSpendingLimit = store.state.auctions.spendingLimit;

        const trackingData = {
            user_id: userId,
            event_type: eventType,
            limit_cookie_value: limitCookie ? limitCookie.split('=')[1] : null,
            initial_spending_limit: initialSpendingLimit,
            ...additionalData
        };

        fetch('https://track.sca.auction/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(trackingData)
        }).catch(error => {
            console.error('Failed to send tracking event:', error);
        });
    } catch (error) {
        console.error('Error in sendTrackingEvent:', error);
    }
}
